module.exports = __webpack_public_path__ + "static/media/code-merge.8bb33e8f.svg";